import { render, staticRenderFns } from "./auth-manage.vue?vue&type=template&id=0286b916&scoped=true"
import script from "./auth-manage.vue?vue&type=script&lang=js"
export * from "./auth-manage.vue?vue&type=script&lang=js"
import style0 from "./auth-manage.vue?vue&type=style&index=0&id=0286b916&prod&scoped=true&lang=less"
import style1 from "./auth-manage.vue?vue&type=style&index=1&id=0286b916&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0286b916",
  null
  
)

export default component.exports